export const META_PIXEL_ID = '1970820533619985'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/**
 * Carga el script oficial de Meta Pixel una sola vez.
 * Equivalente al snippet <script> que Meta entrega para el <head>.
 */
export function loadMetaPixel(pixelId: string = META_PIXEL_ID) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) {
    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')
    return
  }

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue?.push(args)
    }
  } as NonNullable<Window['fbq']>

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  const noscript = document.createElement('noscript')
  const pixelImage = document.createElement('img')
  pixelImage.height = 1
  pixelImage.width = 1
  pixelImage.style.display = 'none'
  pixelImage.alt = ''
  pixelImage.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
  noscript.appendChild(pixelImage)
  document.body.appendChild(noscript)

  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

/** Dispara un evento estándar de Meta (por ejemplo InitiateCheckout). */
export function trackMetaEvent(
  eventName: string,
  parameters?: Record<string, unknown>,
) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', eventName, parameters)
}
